import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { Col, Collapse, Input, Row } from 'antd';

const NoteItensRetention = () => {
  return (
    <Collapse
      destroyInactivePanel={true}
      defaultActiveKey={[
        'pis',
        'cofins',
        'csll',
        'inss',
        'irrf',
        'cpp',
        'others',
      ]}
    >
      <Collapse.Panel key="pis" header="Pis">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota"
              name={['itemTaxes', 'pisWithheldRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Valor"
              name={['itemTaxes', 'pisWithheldValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Base cálculo"
              name={['itemTaxes', 'pisWithheldBase']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="CST"
              name={['itemTaxes', 'pisWithheldCst']}
            >
              <Input />
            </FloatingFormItem>
          </Col>
        </Row>
      </Collapse.Panel>

      <Collapse.Panel key="cofins" header="Cofins">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota"
              name={['itemTaxes', 'cofinsWithheldRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Valor"
              name={['itemTaxes', 'cofinsWithheldValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Base cálculo"
              name={['itemTaxes', 'cofinsWithheldBase']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="CST"
              name={['itemTaxes', 'cofinsWithheldCst']}
            >
              <Input />
            </FloatingFormItem>
          </Col>
        </Row>
      </Collapse.Panel>

      <Collapse.Panel key="csll" header="Csll">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota"
              name={['itemTaxes', 'csllWithheldRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Valor"
              name={['itemTaxes', 'csllWithheldValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </Collapse.Panel>

      <Collapse.Panel key="inss" header="Inss">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota"
              name={['itemTaxes', 'inssWithheldRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Valor"
              name={['itemTaxes', 'inssWithheldValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </Collapse.Panel>

      <Collapse.Panel key="irrf" header="Irrf">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota"
              name={['itemTaxes', 'irrfWithheldRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Valor"
              name={['itemTaxes', 'irrfWithheldValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </Collapse.Panel>

      <Collapse.Panel key="cpp" header="Cpp">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota"
              name={['itemTaxes', 'cppWithheldRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Valor"
              name={['itemTaxes', 'cppWithheldValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </Collapse.Panel>

      <Collapse.Panel key="others" header="Outros">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Outros valores"
              name={['itemTaxes', 'otherWithholdings']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </Collapse.Panel>
    </Collapse>
  );
};

export default NoteItensRetention;
